<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters } from "vuex";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Pagination from "../../../components/pagination.vue";
import formatter from "../../../mixins/formatter";

export default {
    page: {
        title: "Summary",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Pagination
    },
    mixins: [
        formatter
    ],
    data() {
        return {
            title: "Summary",
            totalWingband: 0,
            loading: true,
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            statistics_data: {},
            filter: {
                search: "",
                show: "",
                tab: 1,
                limit: 10,
            },
        };
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
        // Entity name shown in the "No ... found" empty-state row, per active tab.
        emptyLabel() {
            const labels = { 1: "chapters", 2: "farms", 3: "stag registry", 4: "breeders" };
            return labels[this.filter.tab] || "records";
        },
        // Number of columns in the current tab's table, used for the empty-row colspan.
        columnCount() {
            const counts = { 1: 3, 2: 4, 3: 6, 4: 5 };
            return counts[this.filter.tab] || 1;
        },
    },
    methods: {
        ...mapActions("summary", {
            getChapters: "getChapterList",
            getFarms: "getFarmAddressList",
            getStags: "getStagRegistryList",
            getBreeders: "getBreederList",
            getStatistics: "getSummaryStatList",
            exportSummary: "downloadSummary",
        }),
        async initChapterList(p = 1) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
            };
            if (this.filter.tab) {
                pl["tab"] = this.filter.tab;
            }
            if (this.filter.search) {
                pl["search"] = this.filter.search;
            }
            if (this.filter.show) {
                pl["show"] = this.filter.show;
            }
            this.loading = true;
            const data = await this.getChapters(pl);
            this.loading = false;
            this.setListData(data);
        },
        async initFarmList(p = 1) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
            };
            if (this.filter.tab) {
                pl["tab"] = this.filter.tab;
            }
            if (this.filter.search) {
                pl["search"] = this.filter.search;
            }
            if (this.filter.show) {
                pl["show"] = this.filter.show;
            }
            this.loading = true;
            const data = await this.getFarms(pl);
            this.loading = false;
            this.setListData(data);
        },
        async initStagList(p = 1) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
            };
            if (this.filter.tab) {
                pl["tab"] = this.filter.tab;
            }
            if (this.filter.search) {
                pl["search"] = this.filter.search;
            }
            if (this.filter.show) {
                pl["show"] = this.filter.show;
            }
            this.loading = true;
            const data = await this.getStags(pl);
            this.loading = false;
            this.setListData(data);
        },
        async initBreederList(p = 1) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
            };
            if (this.filter.tab) {
                pl["tab"] = this.filter.tab;
            }
            if (this.filter.search) {
                pl["search"] = this.filter.search;
            }
            if (this.filter.show) {
                pl["show"] = this.filter.show;
            }
            this.loading = true;
            const data = await this.getBreeders(pl);
            this.loading = false;
            this.setListData(data);
        },
        // Safely apply a list response. On empty/404/network failure the response
        // is null, so clear the table and let the "No ... found" row show.
        setListData(data) {
            if (data && Array.isArray(data.data)) {
                this.data.list = data.data;
                this.data.links = data.links;
                this.data.current_page = data.current_page;
                this.data.per_page = data.per_page;
                this.data.last_page = data.last_page;
            } else {
                this.data.list = [];
                this.data.links = [];
                this.data.current_page = 1;
                this.data.per_page = this.filter.limit;
                this.data.last_page = 1;
            }
        },
        convertToCsv(objArray) {
            var array =
                typeof objArray != "object" ? JSON.parse(objArray) : objArray;

            var str = "";

            for (var i = 0; i < array.length; i++) {
                var line = "";
                for (var index in array[i]) {
                    if (line != "") line += ",";
                    line += array[i][index];
                }

                str += line + "\r\n";
            }

            return str;
        },
        exportCsvFile(headers, item, fileTitle) {
            var vm = this;
            if (headers) {
                item.unshift(headers);
            }
            var jsonObject = JSON.stringify(item);
            var csv = vm.convertToCsv(jsonObject);

            var exportedFilenmae = fileTitle + ".csv" || "export.csv";

            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, exportedFilenmae);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", exportedFilenmae);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        filterList() {
            if (this.filter.tab == 1) {
                this.initChapterList(1);
            } else if (this.filter.tab == 2) {
                this.initFarmList(1);
            } else if (this.filter.tab == 3) {
                this.initStagList(1);
            } else if (this.filter.tab == 4) {
                this.initBreederList(1);
            }
        },
        resetFilter() {
            this.filter.search = "";
            this.filter.show = "";
            this.filter.tab = 1;
            this.filter.limit = 10;
            this.initChapterList(1);
        },
        async initStatistics() {
            this.loading = true;
            const data = await this.getStatistics();
            console.log(data)
            this.loading = false;
            this.statistics_data = data;
        },
        async printFunction() {
            window.print();
        },
        // async exportData() {
        //     var current = new Date();
        //     var currentDate = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
        //     if (this.filter.tab == 1) {
        //         var headers = {
        //             chapter: "CHAPTER",
        //             banded_cockerels: "BANDED COCKERELS",
        //         };
        //         var itemsFormatted = [];
        //         const arr = await this.data.list;
        //         arr.forEach((item) => {
        //             itemsFormatted.push({
        //                 chapter: item.chapter,
        //                 banded_cockerels: item.banded_cockerels,
        //             });
        //         });
        //         var fileTitle = `Summary List ${currentDate}`;
        //         this.exportCsvFile(headers, itemsFormatted, fileTitle);
        //     } else if (this.filter.tab == 2) {
        //         console.log(this.data.list)
        //         headers = {
        //             farm_name: "FARM NAME",
        //             farm_address: "FARM ADDRESS",
        //             breeder_name: "NAME OF BREEDERS",
        //             banded_cockerels: "BANDED COCKERELS",
        //         };
        //         itemsFormatted = [];
        //         const arr = await this.data.list;
        //         arr.forEach((item) => {
        //             itemsFormatted.push({
        //                 farm_name: item.name,
        //                 farm_address: item.address,
        //                 breeder_name: item.breeder_name,
        //                 banded_cockerels: item.banded_cockerels,
        //             });
        //         });
        //         fileTitle = `Summary List ${currentDate}`;
        //         this.exportCsvFile(headers, itemsFormatted, fileTitle);
        //     } else if (this.filter.tab == 3) {
        //         console.log(this.data.list)
        //         headers = {
        //             stag_registry: "STAG REGISTRY",
        //             farm_name: "FARM NAME",
        //             farm_address: "FARM ADDRESS",
        //             breeder_name: "NAME OF BREEDERS",
        //             chapter: "CHAPTER",
        //             banded_cockerels: "BANDED COCKERELS",
        //         };
        //         itemsFormatted = [];
        //         const arr = await this.data.list;
        //         arr.forEach((item) => {
        //             itemsFormatted.push({
        //                 stag_registry: item.stag_registry,
        //                 farm_name: item.farm_name,
        //                 farm_address: item.farm_address,
        //                 breeder_name: item.breeder_name,
        //                 chapter: item.chapter,
        //                 banded_cockerels: item.banded_cockerels,
        //             });
        //         });
        //         fileTitle = `Summary List ${currentDate}`;
        //         this.exportCsvFile(headers, itemsFormatted, fileTitle);
        //     } else if (this.filter.tab == 4) {
        //         console.log(this.data.list)
        //         headers = {
        //             breeder_name: "NAME OF BREEDERS",
        //             farm_name: "FARM NAME",
        //             farm_address: "FARM ADDRESS",
        //             chapter: "CHAPTER",
        //             banded_cockerels: "BANDED COCKERELS",
        //         };
        //         itemsFormatted = [];
        //         const arr = await this.data.list;
        //         arr.forEach((item) => {
        //             itemsFormatted.push({
        //                 breeder_name: item.name,
        //                 farm_name: item.farm_name,
        //                 farm_address: item.farm_address,
        //                 chapter: item.chapter,
        //                 banded_cockerels: item.banded_cockerels,
        //             });
        //         });
        //         fileTitle = `Summary List ${currentDate}`;
        //         this.exportCsvFile(headers, itemsFormatted, fileTitle);
        //     }
        // },
        async exportData(chapter){
            var pl = {
                chapter: chapter
            }
            await this.exportSummary(pl);
        },
        async exportToPDF() {
            const doc = new jsPDF();
            var tabNames = { 1: 'Chapters', 2: 'Farms', 3: 'Stag Registry', 4: 'Breeder' };
            var tabLabel = tabNames[this.filter.tab] || 'Summary';
            var pdfTitle = "Summary List - " + tabLabel;
            doc.setFontSize(18);
            doc.text(pdfTitle, 105, 10, { align: "center" });
            var tableData;
            var headerTable;
            if(this.filter.tab == 1){
                headerTable = [["#", "Chapter", "Banded Cockerels"]],
                tableData = this.data.list.map((item, index) => [
                index + 1,
                item.chapter || "N/A",
                item.banded_cockerels != null ? this.numToString(item.banded_cockerels) : "N/A",
                ]);
            }else if(this.filter.tab == 2){
                headerTable = [["#", "FARM NAME", "FARM ADDRESS","NAME OF BREEDERS","BANDED COCKERELS"]],
                tableData = this.data.list.map((item, index) => [
                index + 1,
                item.name || "N/A",
                item.address || "N/A",
                item.breeder_name || "N/A",
                item.banded_cockerels != null ? this.numToString(item.banded_cockerels) : "N/A",
                ]);
            }else if(this.filter.tab == 3){
                headerTable = [["#", "STAG REGISTRY","FARM NAME", "FARM ADDRESS","NAME OF BREEDERS","CHAPTER","BANDED COCKERELS"]],
                tableData = this.data.list.map((item, index) => [
                index + 1,
                item.stag_registry || "N/A",
                item.farm_name || "N/A",
                item.farm_address || "N/A",
                item.breeder_name || "N/A",
                item.chapter || "N/A",
                item.banded_cockerels != null ? this.numToString(item.banded_cockerels) : "N/A",
                ]);
            }else if(this.filter.tab == 4){
                headerTable = [["#", "NAME OF BREEDERS", "FARM NAME","FARM ADDRESS","CHAPTER","BANDED COCKERELS"]],
                tableData = this.data.list.map((item, index) => [
                index + 1,
                item.name || "N/A",
                item.farm_name || "N/A",
                item.farm_address || "N/A",
                item.chapter || "N/A",
                item.banded_cockerels != null ? this.numToString(item.banded_cockerels) : "N/A",
                ]);
            }
            doc.autoTable({
            head: headerTable,
            body: tableData,
            startY: 20,
            theme: "grid",
            headStyles: {
                fillColor: [0, 0, 0],
                textColor: [255, 255, 255],
                fontSize: 12,
            },
            bodyStyles: { fontSize: 10 },
            alternateRowStyles: { fillColor: [240, 240, 240] },
            styles: { cellPadding: 4 },
            });
            doc.save("Summary List - " + tabLabel + ".pdf");
        },
    },
    mounted() {
        this.initChapterList(1);
        this.initStatistics();
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-2 p-2">
                    <div class="grid-4">
                        <div class="bg-secondary w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.total_chapters) }}</h1>
                                <h5 class="text-white">Chapter</h5>
                            </div>
                        </div>
                        <div class="bg-secondary w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.total_farms) }}</h1>
                                <h5 class="text-white">Farms</h5>
                            </div>
                        </div>
                        <div class="bg-secondary w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.total_stag_registry) }}</h1>
                                <h5 class="text-white">Stag Registry</h5>
                            </div>
                        </div>
                        <div class="bg-secondary w-100 text-center rounded col-2">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.total_breeders) }}</h1>
                                <h5 class="text-white">Breeder</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="card p-0">
                    <div class="col-lg-12">
                        <div class="card mb-2">
                            <div class="card-body p-0 pb-3">
                                <div class="d-flex flex-wrap px-3 pt-1 gap-2">
                                    <div class="col-12 col-md-5">
                                        <div class="d-flex align-items-end h-100">
                                            <div class="d-flex flex-wrap align-items-center gap-2 custom-border p-1 w-100">
                                                <label class="filter-label">Search:</label>
                                                <input type="text" class="form-control" style="min-width:120px;flex:1;" placeholder="Search..."
                                                    v-model="filter.search">
                                                <button class="btn btn-success" data-toggle="tooltip"
                                                    data-placement="top" title="Apply"
                                                    @click="filterList()">Search</button>
                                                <button class="btn btn-secondary ms-2" @click="resetFilter()">Reset</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-5 disflex align-items-end">
                                        <button class="btn btn-light mx-1" @click="printFunction()" data-toggle="tooltip"
                                            data-placement="top" title="Print"><i
                                                class='bx bx-printer fs-4'></i></button>
                                        <button class="btn btn-light" @click="exportToPDF()" data-toggle="tooltip"
                                            data-placement="top" title="PDF"><i
                                                class='bx bxs-file-pdf fs-4'></i></button>
                                    </div>
                                    <div class="col-12 col-md-2 disflex align-items-center">
                                        <label class="filter-label">Limit:</label>
                                        <select class="form-control w-50" v-model="filter.limit" @change="filterList()">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                            <option value="500">500</option>
                                            <option value="1000">1000</option>
                                            <option value="5000">5000</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabs d-flex ms-1 mt-1">
                        <!-- <h6 @click="filter.tab = 'chapter', filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 'chapter' ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Chapter
                        </h6>
                        <h6 @click="filter.tab = 'farm_address', filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 'farm_address' ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Farm
                            Address</h6>
                        <h6 @click="filter.tab = 'stag_registry', filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 'stag_registry' ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Stag
                            Registry</h6>
                        <h6 @click="filter.tab = 'breeder', filterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 'breeder' ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Breeder
                        </h6> -->
                        <h6 @click="filter.tab = 1, initChapterList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 1 ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Chapter
                        </h6>
                        <h6 @click="filter.tab = 2, initFarmList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 2 ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Farms</h6>
                        <h6 @click="filter.tab = 3, initStagList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 3 ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Stag
                            Registry</h6>
                        <h6 @click="filter.tab = 4, initBreederList()" class="p-2 me-1  cursor-pointer"
                            :class="filter.tab == 4 ? 'bg-white  text-color-tabs border border-bottom-0' : 'bg-light'">
                            Breeder
                        </h6>
                    </div>
                    <div class="tbl-header custom-overflow">
                        <table class="mb-0 table">
                            <thead>
                                <tr class="bg-light">
                                    <!-- Chapter -->
                                    <th v-if="this.filter.tab === 1">Chapter</th>
                                    <!-- Farms -->
                                    <th v-if="this.filter.tab === 2">Farm Name</th>
                                    <th v-if="this.filter.tab === 2">Farm Address</th>
                                    <th v-if="this.filter.tab === 2">Name of Breeders</th>
                                    <!-- Stag -->
                                    <th v-if="this.filter.tab === 3">Stag Registry</th>
                                    <th v-if="this.filter.tab === 3">Farm Name</th>
                                    <th v-if="this.filter.tab === 3">Farm Address</th>
                                    <th v-if="this.filter.tab === 3">Name of Breeders</th>
                                    <th v-if="this.filter.tab === 3">Chapter</th>
                                    <!-- Breeders -->
                                    <th v-if="this.filter.tab === 4">Name of Breeders</th>
                                    <th v-if="this.filter.tab === 4">Farm Name</th>
                                    <th v-if="this.filter.tab === 4">Farm Address</th>
                                    <th v-if="this.filter.tab === 4">Chapter</th>
                                    <th>Banded Cockerels</th>
                                    <th v-if="this.filter.tab === 1">Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="row, index in this.data.list" :key="index">
                                    <!-- Chapter -->
                                    <td v-if="this.filter.tab === 1">
                                        {{ row.chapter }}
                                    </td>
                                    <!-- Farms -->
                                    <td v-if="this.filter.tab === 2">
                                        {{ row.name }}
                                    </td>
                                    <td v-if="this.filter.tab === 2">
                                        {{ row.address }}
                                    </td>
                                    <td v-if="this.filter.tab === 2">
                                        {{ row.breeder_name }}
                                    </td>
                                    <!-- Stag -->
                                    <td v-if="this.filter.tab === 3">
                                        {{ row.stag_registry }}
                                    </td>
                                    <td v-if="this.filter.tab === 3">
                                        {{ row.farm_name }}
                                    </td>
                                    <td v-if="this.filter.tab === 3">
                                        {{ row.farm_address }}
                                    </td>
                                    <td v-if="this.filter.tab === 3">
                                        {{ row.breeder_name }}
                                    </td>
                                    <td v-if="this.filter.tab === 3">
                                        {{ row.chapter }}
                                    </td>
                                    <!-- Breeder -->
                                    <td v-if="this.filter.tab === 4">
                                        {{ row.name }}
                                    </td>
                                    <td v-if="this.filter.tab === 4">
                                        {{ row.farm_name }}
                                    </td>
                                    <td v-if="this.filter.tab === 4">
                                        {{ row.farm_address }}
                                    </td>
                                    <td v-if="this.filter.tab === 4">
                                        {{ row.chapter }}
                                    </td>
                                    <td>
                                        {{ numToString(row.banded_cockerels) }}
                                    </td>
                                    <td v-if="this.filter.tab === 1">
                                        <button class="btn btn-light mx-1" @click="exportData(row.chapter)" data-toggle="tooltip"
                                            data-placement="top" title="Export"><i
                                                class='bx bx-export fs-4'></i></button>
                                    </td>
                                </tr>
                                <tr v-if="!this.data.list || this.data.list.length === 0">
                                    <td :colspan="columnCount" class="text-center text-muted py-3">
                                        No {{ emptyLabel }} found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="loading" class="loader">Loading...</div>
                    </div>
                    <Pagination v-if="filter.tab == 1" :data="data" @emitPage="initChapterList" class="me-2" />
                    <Pagination v-if="filter.tab == 2" :data="data" @emitPage="initFarmList" class="me-2" />
                    <Pagination v-if="filter.tab == 3" :data="data" @emitPage="initStagList" class="me-2" />
                    <Pagination v-if="filter.tab == 4" :data="data" @emitPage="initBreederList" class="me-2" />
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}
</style>